import http from '../utils/http';

export const getNotifications = (query) => http.get(`/messaging/notifications${query ? `?${query}` : ''}`);

export const sendNotification = (data) =>
  http.post('/messaging', {
    ...data,
  });
